export const generateComponentId = (prefix?: string) => (prefix || 'node') + '_' + guidGenerator()

export const guidGenerator = () => {
  // tslint:disable-next-line:no-bitwise
  const S4 = () =>  (((1+Math.random())*0x10000)|0).toString(16).substring(1)
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4())
}
